import React from "react";
import * as R from "ramda";
import { any, arrayOf, func, shape, string } from "prop-types";

import Select from "../Select/Select.jsx";
import MultiSelect from "../MultiSelect/MultiSelect.jsx";
import DatePicker from "../DatePicker/DatePicker.jsx";

const optionShape = shape({
  id: any.isRequired, // could be string or number
  label: string.isRequired,
});

const propTypes = {
  onChange: func.isRequired,
  activeFilter: string, // keep active filter open
  values: shape({
    bedrooms: optionShape,
    bathrooms: optionShape,
    floors: optionShape,
    priceRange: string,
  }).isRequired,
  options: shape({
    bedrooms: arrayOf(optionShape),
    bathrooms: arrayOf(optionShape),
    floors: arrayOf(optionShape),
    price: arrayOf(optionShape),
  }),
};

const Filters = props => {
  const { options, onChange, values } = props;

  const FilterSelect = props => {
    const { id, ...otherProps } = props;
    const items = options[id];

    if (!items || R.isEmpty(items)) {
      return null;
    }

    return (
      <div className="action-bar__filter">
        {id === "attributes" ? (
          <MultiSelect
            selectProps={{
              items,
              selectedItems: values[id],
              itemToString: R.prop("label"),
            }}
            handleChange={selectedItems => {
              const selectedIds = R.map(R.prop("id"), selectedItems);
              onChange(id, selectedIds);
            }}
            {...otherProps}
          />
        ) : (
          <Select
            selectProps={{
              items,
              itemToString: R.prop("label"),
              selectedItem: values[id],
              onSelectedItemChange: changes => {
                onChange(id, R.prop("id", changes.selectedItem));
              },
            }}
            {...otherProps}
          />
        )}
      </div>
    );
  };
  FilterSelect.propTypes = {
    id: string.isRequired,
  };

  return (
    <div className="action-bar__filters">
      <FilterSelect id="price" placeholder="Price Range" />
      <FilterSelect id="bedrooms" placeholder="Bedrooms" />
      <FilterSelect id="bathrooms" placeholder="Bathrooms" />
      <FilterSelect id="attributes" placeholder="Features" />
      <FilterSelect id="floors" placeholder="Floors" />
      <div className="action-bar__filter action-bar__filter--date-picker">
        <DatePicker
          date={values.available_on}
          onChange={date => onChange("available_on", date)}
        />
      </div>
    </div>
  );
};

Filters.propTypes = propTypes;
export default Filters;
